import { defineStore } from 'pinia';
import getters from './getters';
import actions from './actions';
function initState() {
    return {
        median: '',
        estPriceValue: '',
        rental: '',
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
